/**
 * 个人日志后端地址（/user/record，不走 admin JWT）
 * 与小程序 bjProject/common/apiConfig.js 保持一致，直连后端 8080
 */
export const RECORD_API_BASE =
  process.env.VUE_APP_USER_BASE_API ||
  process.env.VUE_APP_USER_URL ||
  (process.env.NODE_ENV === 'development'
    ? 'http://192.168.31.227:8080'
    : 'https://java.1.qianduanxiaozhou.xyz')
